import type { ReactNode } from 'react'
import { cx } from '../../cx'
import styles from './StatCard.module.css'

export interface StatCardProps {
  /** Etykieta mono nad wartością (spec 03 §8: uppercase, letter-spacing). */
  label: string
  value: ReactNode
  /** Jednostka obok wartości — „dni", „h", „zł". */
  unit?: string
  note?: ReactNode
  /** Wariant różowy: karta niosąca zadanie do wykonania (np. „Do podpisu"). */
  highlighted?: boolean
  /** Karta klikalna prowadzi do zakładki ze szczegółami. */
  onClick?: () => void
  className?: string
}

/** Kafel KPI portalu i pulpitu HR (spec 03 §8 „StatCard / KPI"). */
export function StatCard({
  label,
  value,
  unit,
  note,
  highlighted = false,
  onClick,
  className,
}: StatCardProps) {
  const content = (
    <>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {value}
        {unit ? <span className={styles.unit}>{unit}</span> : null}
      </span>
      {note !== undefined ? <span className={styles.note}>{note}</span> : null}
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        className={cx(styles.card, styles.clickable, highlighted && styles.highlighted, className)}
        onClick={onClick}
      >
        {content}
      </button>
    )
  }

  return (
    <div className={cx(styles.card, highlighted && styles.highlighted, className)}>{content}</div>
  )
}
